"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productOverrides = exports.toggleProps = exports.productAttributes = exports.productsData = exports.product = void 0;
const prop_types_1 = require("prop-types");
const attributeValue = (0, prop_types_1.shape)({
    code: prop_types_1.string,
    label: prop_types_1.string,
    swatch: prop_types_1.string
});
const configurableAttribute = (0, prop_types_1.shape)({
    code: prop_types_1.string,
    displayName: prop_types_1.string,
    // displayType: string,
    // default: string,
    values: (0, prop_types_1.arrayOf)(attributeValue)
});
const magentoBundleOptions = (0, prop_types_1.shape)({
    id: prop_types_1.number,
    quantity: prop_types_1.number,
    value: prop_types_1.string
});
const variant = (0, prop_types_1.shape)({
    sku: prop_types_1.string,
    price: prop_types_1.number,
    hiddenAttributeValues: (0, prop_types_1.objectOf)((0, prop_types_1.arrayOf)(prop_types_1.string)), // which attribute options should i hide when this variant is selected
    magentoBundleOptions,
    inStock: prop_types_1.bool
    // as many attributes as you want
});
const product = (0, prop_types_1.shape)({
    name: prop_types_1.string,
    productCode: prop_types_1.string,
    variants: (0, prop_types_1.arrayOf)(variant),
    options: (0, prop_types_1.arrayOf)(configurableAttribute),
    configurableAttributes: (0, prop_types_1.arrayOf)(prop_types_1.string) // which attributes should i compare when trying filtering for variants
});
exports.product = product;
// comes from data still hardcoded in coresite node, see pages/product/content
const toggleProps = (0, prop_types_1.oneOfType)([
    (0, prop_types_1.shape)({
        toggleType: prop_types_1.string,
        toggleContent: prop_types_1.node,
        toggleLabel: prop_types_1.string,
        toggleModalHeader: prop_types_1.string,
        toggleClickHandler: prop_types_1.func
    }),
    (0, prop_types_1.shape)({
        label: prop_types_1.string,
        isCustomLabel: prop_types_1.bool
    })
]);
exports.toggleProps = toggleProps;
const productsData = (0, prop_types_1.arrayOf)(product);
exports.productsData = productsData;
const productAttributes = (0, prop_types_1.objectOf)(prop_types_1.object);
exports.productAttributes = productAttributes;
const productOverride = (0, prop_types_1.shape)({
    skuQuery: prop_types_1.string,
    qtyQuery: prop_types_1.number
});
const productOverrides = (0, prop_types_1.objectOf)(productOverride);
exports.productOverrides = productOverrides;
//# sourceMappingURL=selection.types.js.map